import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { routes } from './app.routes';
import { ColorSchemeService } from './core/scheme/color-scheme.service';
import { TranslocoHttpLoader } from './core/transloco/transloco-http.loader';
import { provideFaIcons } from './shared/icons/fa-icons.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(),
    provideFaIcons(),
    // สร้าง ColorSchemeService ตอนเริ่มแอปเพื่อให้โหมด auto ติดตามการเปลี่ยนของระบบตั้งแต่แรก
    provideAppInitializer(() => {
      inject(ColorSchemeService);
    }),
    provideTransloco({
      config: {
        availableLangs: [
          { id: 'th', label: 'ไทย' },
          { id: 'en', label: 'English' },
        ],
        defaultLang: 'th',
        fallbackLang: 'th',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
